var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{style:('height: '+_vm.Height),attrs:{"id":"tradingview"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }